/**
 * NotificationToast.jsx
 * Created by Destin Frasier on 9/11/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as Icons from '../../sharedComponents/icons/Icons';

const propTypes = {
    type: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    caption: PropTypes.string,
    expirationTimeout: PropTypes.number
};

const defaultProps = {
    type: 'info',
    title: '',
    subtitle: '',
    caption: '',
    expirationTimeout: 10000
};

export default class NotificationToast extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            hideComponent: false
        };
        this.initInterval = null;
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount(){
        this.initInterval = window.setTimeout(this.handleClose, this.props.expirationTimeout);
    }

    componentWillUnmount(){
        window.clearTimeout(this.initInterval);
    }

    handleClose() {
        this.setState({ hideComponent: true });
    }

    render() {
        return (
            <div className={cx(`rec-notification-toast-${this.props.type}`, { hide: this.state.hideComponent })}>
                <div className="rec-notification-title">{this.props.title}</div>
                <p>{this.props.subtitle}</p>
                <p className="rec-caption">{this.props.caption}</p>
                <button
                    className="rec-notification-close"
                    onClick={this.handleClose}>
                    <Icons.IconClose className="rec-icon-close" />
                </button>
            </div>
        );
    }
}

NotificationToast.propTypes = propTypes;
NotificationToast.defaultProps = defaultProps;
